/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckSelfPublishTag } from './deck-self-publish-tag';

export interface DeckPitchSelfPublishFileTypeList {
  readonly id: string;
  readonly name: string;
  readonly tag: DeckSelfPublishTag;
  readonly slug: string | null;
  readonly inactive: boolean;
}
